import { ManifestComponentExtensionType } from '../ManifestStore';
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
export class ExternalPresetsHandler extends AbstractExternalAPIHandler {
  getAppliedPreset(editorPointer, type) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          var _this$dm$components$i, _this$dm$components$p;
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          return contextualEditorPointer.innerElementPath ? ((_this$dm$components$i = this.dm.components.innerElements.presets.get(contextualEditorPointer.documentPointer, contextualEditorPointer.innerElementPath)) == null ? void 0 : _this$dm$components$i.presetName) ?? '' : ((_this$dm$components$p = this.dm.components.presets.get(contextualEditorPointer.documentPointer)) == null ? void 0 : _this$dm$components$p.presetName) ?? '';
        }
      case ManifestComponentExtensionType.OOI:
        {
          // console.error('OOI presets are not supported - yet!');
          return '';
        }
      default:
        return null;
    }
  }
  applyPreset(editorPointer, type, presetName) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          contextualEditorPointer.innerElementPath ? this.dm.components.innerElements.presets.set(contextualEditorPointer.documentPointer, contextualEditorPointer.innerElementPath, {
            presetName
            // type: `${builderType}.Presets`, // TODO: should we add this?
          }) : this.dm.components.presets.set(contextualEditorPointer.documentPointer, {
            presetName
            // type: `${builderType}.Presets`, // TODO: should we add this?
          });
          return;
        }
      case ManifestComponentExtensionType.OOI:
        {
          // console.error('OOI presets in DM are not supported - yet!');
          return;
        }
      default:
        throw new Error('not implemented');
    }
  }
}
//# sourceMappingURL=ExternalPresetsHandler.js.map